export default "__VITE_ASSET__w0A0z8h___"